import { openRoute, permissionsRoute, resetRouter } from '@/router'
import router from "@/router"
import { login } from "@/common/api"


const hasPermission = (roles, route) => {
    if (!route.meta || !route.meta.roles) return true
    return roles.some(role => route.meta.roles.includes(role))
}

export const filterRoutes = (routes, roles) => {
    const res = []
    routes.forEach(item => {
        const tmp = { ...item }
        if (hasPermission(roles, tmp)) {
            if (tmp.children) {
                tmp.children = filterRoutes(tmp.children, roles)
            }
            res.push(tmp)
        }
    })
    return res
}



const state = {
    userInfo: null,
    routes: [] // 当前用户的完整路由
}

const mutations = {
    SET_USER_INFO(state, userInfo) {
        state.userInfo = userInfo
    },
    SET_ROUTES(state, routes) {
        state.routes = openRoute.concat(routes)
    }
}

const actions = {
    // 登录
    login({ commit }, userInfo) {
        return new Promise((resolve, reject) => {
            login(userInfo).then(res => {
                if (res.success) {
                    commit('SET_USER_INFO', res.data)
                    localStorage.setItem("userInfo", JSON.stringify(res.data));
                    resolve()
                } else {
                    const errorMsg = res.message || '服务异常';
                    reject(new Error(errorMsg));
                }
            }).catch(reject)
        })
    },
    // 生成动态路由并添加到 router
    generateRoutes({ commit }, roles) {
        return new Promise(resolve => {
            let allowRoutes
            if (roles.includes('admin')) {
                // admin 拥有全部权限
                allowRoutes = permissionsRoute
            } else {
                // 按角色过滤
                allowRoutes = filterRoutes(permissionsRoute, [roles])
            }
            commit('SET_ROUTES', allowRoutes)
            // 动态添加路由
            router.addRoutes(allowRoutes)
            resolve(allowRoutes)
        })
    },

    // 登出
    logout({ commit }) {
        commit('SET_USER_INFO', null)
        commit('SET_ROUTES', [])
        localStorage.removeItem('userInfo')
        resetRouter() // 重置路由
    }
}




export default {
    namespaced: true,
    state,
    mutations,
    actions
}